export default __webpack_public_path__ + "static/media/icon-paid.690d7aee.svg";